import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { numberFormat } from '../../../../helpers/numberFormat';
import Modal from 'react-bootstrap/Modal';
import { AddParticipantComp, EditParticipantComp, AddParticipantBpComp, EditParticipantBpComp } from '../..';
import { getStartEndDate } from '../../../../helpers/getStartEndDate';
import { getStartEndDateBp } from '../../../../helpers/getStartEndDateBp';
import { IconPencil, IconTrash, IconSquareRoundedPlusFilled } from '@tabler/icons-react';

const FormKatalogParticipant = () => {

    const size = useWindowSize();

    function useWindowSize() {
        // Initialize state with undefined width/height so server and client renders match
        // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
        const [windowSize, setWindowSize] = useState({
            width: undefined,
            height: undefined,
        });
        useEffect(() => {
            // Handler to call on window resize
            function handleResize() {
                // Set window width/height to state
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
            // Add event listener
            window.addEventListener("resize", handleResize);
            // Call handler right away so state gets updated with initial window size
            handleResize();
            // Remove event listener on cleanup
            return () => window.removeEventListener("resize", handleResize);
        }, []); // Empty array ensures that effect is only run on mount
        return windowSize;
    }

    const dispatch = useDispatch()
    const programSelected = useSelector(state => state.programSelected)
    const participants = useSelector(state => state.participants)
    const scheduleSelected = useSelector(state => state.scheduleSelected)

    const bpSelected = useSelector(state => state.bpSelected)
    const bpParticipants = useSelector(state => state.bpParticipants)
    const bpScheduleSelected = useSelector(state => state.bpScheduleSelected)

    const [showParticipantBp, setShowParticipantBp] = useState(false);
    const [showParticipant, setShowParticipant] = useState(false);
    const [showEditParticipant, setShowEditParticipant] = useState(false);
    const [showEditParticipantBp, setShowEditParticipantBp] = useState(false);
    const [bpId, setbpId] = useState('');
    const [programId, setProgramId] = useState('');
    const [participant, setParticipant] = useState('');
    const [participantBp, setParticipantBp] = useState('');

    const handleAddParticipant = (programId) => {
        setShowParticipant(true)
        setProgramId(programId)
    }

    const handleEditParticipant = (participant) => {
        setShowEditParticipant(true)
        setParticipant(participant)
    }

    const handleAfterSubmitParticipant = () => {
        setShowParticipantBp(false)
        setShowParticipant(false)
        setShowEditParticipant(false)
        setShowEditParticipantBp(false)
        setProgramId('')
        setbpId('')
    }

    const handleRemoveParticipant = (participant) => {
        dispatch({
            type: 'REMOVE_PARTICIPANTS',
            payload: { idPeserta: participant.idPeserta }
        });

        dispatch({
            type: 'UNSET_PARTICIPANT_TO_SCHEDULE',
            programId: participant.programId,
            payload: participant.emailPeserta
        });

        const findSchedule = scheduleSelected.find(schedule => schedule.programId === participant.programId)

        if (findSchedule.participants.length === 1) {
            dispatch({ type: 'SET_VALIDATE', 'value': false });
        }
    }

    const handleAddParticipantBp = (bpId) => {
        // console.log(bpId)
        // return false
        setShowParticipantBp(true)
        setbpId(bpId)
    }

    const handleEditParticipantBp = (participant) => {
        setShowEditParticipantBp(true)
        setParticipantBp(participant)
    }

    const handleRemoveParticipantBp = (participant) => {
        dispatch({
            type: 'REMOVE_BP_PARTICIPANTS',
            payload: { idPeserta: participant.idPeserta }
        });

        dispatch({
            type: 'UNSET_BP_PARTICIPANT_TO_SCHEDULE',
            bpId: participant.bpId,
            payload: participant.emailPeserta
        });

        const findBp = bpScheduleSelected.find(bp => bp.bpId === participant.bpId)

        if (findBp.participants.length === 1) {
            dispatch({ type: 'SET_VALIDATE', 'value': false });
        }
    }

    return (
        <div style={{ filter: showParticipant === true || showParticipantBp === true ? 'blur(8px)' : '' }}>
            <div className='col-lg-12' style={{ marginBottom: '2%' }}>
                {
                    size.width < 500 ?
                        <h5>Metode Pembayaran & Data Peserta</h5>
                        :
                        <h3 style={{ fontSize: '20px', fontWeight: '600' }}>Metode Pembayaran & Data Peserta</h3>
                }
                <hr style={{ marginBottom: '2%', marginTop: '2%' }}></hr>
                <div className='row mb-2'>
                    {
                        size.width < 500 ?
                            <p style={{ fontSize: '14px', marginBottom: '2%' }}>2. Lengkapi Data Peserta berikut</p>
                            :
                            <p style={{ fontSize: '16px', fontWeight: '400', marginBottom: '2%' }}>2. Lengkapi Data Peserta berikut</p>
                    }
                </div>
            </div>
            {
                bpSelected.map((bps, key) =>
                    <div className='col-lg-12' style={{ marginBottom: '2%' }}>
                        <div className="card">
                            {
                                size.width < 500 ?
                                    <>
                                        <div className="card-body">
                                            <div className='row'>
                                                <div className='col-lg-4' style={{ color: '#5E6278', fontSize: '14px' }}>
                                                    Program Bundling
                                                </div>
                                                <div className='col-lg-4' style={{ color: '#000000', fontSize: '14px', fontWeight: '600' }}>
                                                    {bps.name}
                                                </div>
                                                <div className='col-lg-4' style={{ textAlign: 'right' }}>
                                                    <button className="btn btn-primary" style={{ fontWeight: '400', backgroundColor: '#0C86D9', color: '#F2F2F2' }}>
                                                        <IconSquareRoundedPlusFilled
                                                            width={28}
                                                            height={28}
                                                        /> &nbsp;
                                                        Tambah Peserta
                                                    </button>
                                                </div>
                                            </div>
                                            <div className='row mt-2'>
                                                <div className='col-lg-3'>
                                                </div>
                                                <div className='col-lg-9'>
                                                    <span className="badge" style={{ backgroundColor: '#26D07C', color: '#F2F2F2' }}>Available</span>
                                                </div>
                                            </div>
                                            <div className='row mt-2'>
                                                <div className='col-lg-3' style={{ color: '#5E6278', fontSize: '14px' }}>
                                                    Harga
                                                </div>
                                                <div className='col-lg-9' style={{ color: '#5E6278', fontSize: '14px', fontWeight: '400' }}>
                                                    Rp. {numberFormat(bps.price)} <small style={{ fontStyle: 'italic', fontSize: '12px' }}>(* dikenakan PPN%)</small>
                                                </div>
                                            </div>
                                            <hr></hr>
                                            {
                                                bps.BundlingProgramItems.map((bpi, key) =>
                                                    <>
                                                        <div className='row'>
                                                            <div className='col-lg-3' style={{ color: '#5E6278', fontSize: '12px', fontWeight: '400' }}>
                                                                Program {key + 1}
                                                            </div>
                                                            <div className='col-lg-9' style={{ color: '#000000', fontSize: '12px', fontWeight: '600' }}>
                                                                {bpi.Program.name}
                                                            </div>
                                                        </div>
                                                        <div className='row mt-2'>
                                                            <div className='col-lg-3' style={{ color: '#5E6278', fontSize: '12px', fontWeight: '400' }}>
                                                                Jadwal Program {key + 1}
                                                            </div>
                                                            <div className='col-lg-9' style={{ color: '#5E6278', fontSize: '12px', fontWeight: '400' }}>
                                                                {getStartEndDateBp(bpScheduleSelected, bpi.Program.id)}
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            }
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className="card-body">
                                            <div className='row'>
                                                <div className='col-lg-3' style={{ color: '#5E6278', fontSize: '16px', fontWeight: '400' }}>
                                                    Program Bundling
                                                </div>
                                                <div className='col-lg-5' style={{ color: '#000000', fontSize: '16px', fontWeight: '600' }}>
                                                    {bps.name}
                                                </div>
                                                <div className='col-lg-4' style={{ textAlign: 'right' }}>
                                                    <button onClick={() => handleAddParticipantBp(bps.id)} className="btn btn-primary" style={{ fontWeight: '400', backgroundColor: '#0C86D9', color: '#F2F2F2' }}>
                                                        <IconSquareRoundedPlusFilled
                                                            width={28}
                                                            height={28}
                                                        /> &nbsp;
                                                        Tambah Peserta
                                                    </button>
                                                </div>
                                            </div>
                                            <div className='row mt-2'>
                                                <div className='col-lg-3'>
                                                </div>
                                                <div className='col-lg-9'>
                                                    <span className="badge" style={{ backgroundColor: '#26D07C', color: '#F2F2F2' }}>Available</span>
                                                </div>
                                            </div>
                                            <div className='row mt-2'>
                                                <div className='col-lg-3' style={{ color: '#5E6278', fontSize: '16px', fontWeight: '400' }}>
                                                    Harga
                                                </div>
                                                <div className='col-lg-9' style={{ color: '#5E6278', fontSize: '16px', fontWeight: '400' }}>
                                                    Rp. {numberFormat(bps.price)} <small style={{ fontStyle: 'italic', fontSize: '12px' }}>(* dikenakan PPN%)</small>
                                                </div>
                                            </div>
                                            <hr></hr>
                                            {
                                                bps.BundlingProgramItems.map((bpi, key) =>
                                                    <>
                                                        <div className='row'>
                                                            <div className='col-lg-3' style={{ color: '#5E6278', fontSize: '16px', fontWeight: '400' }}>
                                                                Program {key + 1}
                                                            </div>
                                                            <div className='col-lg-9' style={{ color: '#000000', fontSize: '16px', fontWeight: '600' }}>
                                                                {bpi.Program.name}
                                                            </div>
                                                        </div>
                                                        <div className='row mt-1 mb-4'>
                                                            <div className='col-lg-3' style={{ color: '#5E6278', fontSize: '16px', fontWeight: '400' }}>
                                                                Jadwal Program {key + 1}
                                                            </div>
                                                            <div className='col-lg-9' style={{ color: '#5E6278', fontSize: '16px', fontWeight: '400' }}>
                                                                {getStartEndDateBp(bpScheduleSelected, bpi.Program.id)}
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            }

                                            <div className='row mb-5'>
                                                <div className="table-responsive">
                                                    {
                                                        bpParticipants.length > 0 ?
                                                            <table className="table">
                                                                <thead>
                                                                    <tr className="fw-bold text-gray-800 border-bottom border-gray-200">
                                                                        <th className='text-center'>Nama</th>
                                                                        <th className='text-center'>Sapaan</th>
                                                                        <th className='text-center'>Email</th>
                                                                        <th className='text-center'>Nomor HP</th>
                                                                        <th className='text-center'>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        bpParticipants.map((participant, j) =>
                                                                            <>
                                                                                <tr className="fw-bold text-gray-800 border-bottom border-gray-200">
                                                                                    <td className='text-center'>{participant.namaDepanPeserta} {participant.namaBelakangPeserta}</td>
                                                                                    <td className='text-center'>{participant.salutationPeserta}</td>
                                                                                    <td className='text-center'>{participant.emailPeserta}</td>
                                                                                    <td className='text-center'>{participant.hpPeserta}</td>
                                                                                    <td className='text-center'>
                                                                                        <span onClick={() => handleEditParticipantBp(participant)} className="btn btn-icon btn-warning"><IconPencil width="18px" height="18px" /></span>
                                                                                        &nbsp;
                                                                                        <span onClick={() => handleRemoveParticipantBp(participant)} className="btn btn-icon btn-danger"><IconTrash width="18px" height="18px" /></span>
                                                                                    </td>
                                                                                </tr>
                                                                                <tr className="fw-bold fs-7 text-gray-800 border-bottom border-gray-200">
                                                                                </tr>
                                                                            </>
                                                                        )}
                                                                </tbody>
                                                            </table>
                                                            :
                                                            ''
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </>
                            }
                        </div>
                    </div >
                )
            }

            {
                programSelected.map((ps, j) =>
                    <div className='col-lg-12' style={{ marginBottom: '2%' }}>
                        <div className="card">
                            {
                                size.width < 500 ?
                                    <>
                                        <div className="card-body">
                                            <div className='row'>
                                                <div className='col-lg-3' style={{ color: '#5E6278', fontSize: '14px' }}>
                                                    Nama Program
                                                </div>
                                                <div className='col-lg-9' style={{ color: '#000000', fontSize: '14px', fontWeight: '600' }}>
                                                    {ps.name}
                                                </div>
                                            </div>
                                            <div className='row mt-2'>
                                                <div className='col-lg-3'>
                                                </div>
                                                <div className='col-lg-9'>
                                                    <span className="badge" style={{ backgroundColor: '#26D07C', color: '#F2F2F2' }}>Available</span>
                                                </div>
                                            </div>
                                            <div className='row mt-2'>
                                                <div className='col-lg-3' style={{ color: '#5E6278', fontSize: '14px' }}>
                                                    Harga
                                                </div>
                                                <div className='col-lg-9' style={{ color: '#5E6278', fontSize: '14px', fontWeight: '400' }}>
                                                    Rp. {numberFormat(ps.price)} <small style={{ fontStyle: 'italic', fontSize: '12px' }}>(* dikenakan PPN%)</small>
                                                </div>
                                            </div>
                                            <div className='row mt-2'>
                                                <div className='col-lg-3' style={{ color: '#5E6278', fontSize: '14px' }}>
                                                    Jadwal Program
                                                </div>
                                                <div className='col-lg-9' style={{ color: '#5E6278', fontSize: '14px', fontWeight: '400' }}>
                                                    {getStartEndDate(scheduleSelected, ps.id)}
                                                </div>
                                            </div>
                                            <div className='row mt-3'>
                                                <div className='col-12 mt-3' style={{ textAlign: 'right' }}>
                                                    {
                                                        size.width < 500 ?
                                                            <button onClick={() => handleAddParticipant(ps.id)} className="btn btn-sm btn-primary">
                                                                <IconSquareRoundedPlusFilled
                                                                    width={22}
                                                                    height={22}
                                                                /> &nbsp;
                                                                Tambah Peserta
                                                            </button>
                                                            :
                                                            <button onClick={() => handleAddParticipant(ps.id)} className="btn btn-primary">
                                                                <IconSquareRoundedPlusFilled
                                                                    width={28}
                                                                    height={28}
                                                                /> &nbsp;
                                                                Tambah Peserta
                                                            </button>
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className="card-body">
                                            <div className='row'>
                                                <div className='col-lg-3' style={{ color: '#5E6278', fontSize: '16px', fontWeight: '400' }}>
                                                    Nama Program
                                                </div>
                                                <div className='col-lg-9' style={{ color: '#000000', fontSize: '16px', fontWeight: '600' }}>
                                                    {ps.name}
                                                </div>
                                            </div>
                                            <div className='row mt-2'>
                                                <div className='col-lg-3'>
                                                </div>
                                                <div className='col-lg-9'>
                                                    <span className="badge" style={{ backgroundColor: '#26D07C', color: '#F2F2F2' }}>Available</span>
                                                </div>
                                            </div>
                                            <div className='row mt-2'>
                                                <div className='col-lg-3' style={{ color: '#5E6278', fontSize: '16px', fontWeight: '400' }}>
                                                    Harga
                                                </div>
                                                <div className='col-lg-9' style={{ color: '#5E6278', fontSize: '16px', fontWeight: '400' }}>
                                                    Rp. {numberFormat(ps.price)} <small style={{ fontStyle: 'italic', fontSize: '12px' }}>(* dikenakan PPN%)</small>
                                                </div>
                                            </div>
                                            <div className='row mt-2'>
                                                <div className='col-lg-3' style={{ color: '#5E6278', fontSize: '16px', fontWeight: '400' }}>
                                                    Jadwal Program
                                                </div>
                                                <div className='col-lg-9' style={{ color: '#5E6278', fontSize: '16px', fontWeight: '400' }}>
                                                    {getStartEndDate(scheduleSelected, ps.id)}
                                                </div>
                                            </div>
                                            <div className='row mt-3 mb-3'>
                                                <div className='col-12' style={{ textAlign: 'right' }}>
                                                    <button onClick={() => handleAddParticipant(ps.id)} className="btn btn-primary">
                                                        <IconSquareRoundedPlusFilled
                                                            width={28}
                                                            height={28}
                                                        /> &nbsp;
                                                        Tambah Peserta
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                            }
                            <div className="table-responsive" style={{ marginLeft: '2%', marginRight: '2%' }}>
                                {
                                    participants.length > 0 ?
                                        <table className="table">
                                            <thead>
                                                <tr className="fw-bold text-gray-800 border-bottom border-gray-200">
                                                    <th className='text-center'>Nama</th>
                                                    <th className='text-center'>Sapaan</th>
                                                    <th className='text-center'>Email</th>
                                                    <th className='text-center'>Nomor HP</th>
                                                    <th className='text-center'>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    participants.map((participant, j) =>
                                                        ps.id === participant.programId ?
                                                            <>
                                                                <tr className="fw-bold text-gray-800 border-bottom border-gray-200">
                                                                    <td className='text-center'>{participant.namaDepanPeserta} {participant.namaBelakangPeserta}</td>
                                                                    <td className='text-center'>{participant.salutationPeserta}</td>
                                                                    <td className='text-center'>{participant.emailPeserta}</td>
                                                                    <td className='text-center'>{participant.hpPeserta}</td>
                                                                    <td className='text-center'>
                                                                        <span onClick={() => handleEditParticipant(participant)} className="btn btn-icon btn-warning"><IconPencil width="18px" height="18px" /></span>
                                                                        &nbsp;
                                                                        <span onClick={() => handleRemoveParticipant(participant)} className="btn btn-icon btn-danger"><IconTrash width="18px" height="18px" /></span>
                                                                    </td>
                                                                </tr>
                                                                <tr className="fw-bold fs-7 text-gray-800 border-bottom border-gray-200">
                                                                </tr>
                                                            </>
                                                            :
                                                            ''
                                                    )}
                                            </tbody>
                                        </table>
                                        :
                                        ''
                                }

                            </div>
                        </div>
                    </div >
                )
            }

            <Modal
                show={showParticipant}
                size='lg'
                onHide={() => setShowParticipant(false)}
                centered
            >
                <Modal.Header
                    closeButton
                    style={{ backgroundColor: '#0C86D9', color: '#FFFFFF' }}
                >
                    <Modal.Title>
                        <div>
                            <h2 className='mt-3'>Tambah Peserta</h2>
                            <p className='mb-3' style={{ fontWeight: 'normal', fontSize: '15px', color: '#FFFFFF' }}>Silahkan isi data peserta berikut</p>
                        </div>
                    </Modal.Title>
                </Modal.Header >
                <Modal.Body style={{ backgroundColor: '#FFFFFF' }}>
                    <AddParticipantComp
                        programId={programId}
                        close={() => handleAfterSubmitParticipant()}
                    />
                </Modal.Body>
            </Modal>

            <Modal
                show={showEditParticipant}
                size='lg'
                onHide={() => setShowEditParticipant(false)}
                centered
            >
                <Modal.Header
                    closeButton
                    style={{ backgroundColor: '#0C86D9', color: '#FFFFFF' }}
                >
                    <Modal.Title>
                        <div className='mt-3 mb-3'>
                            <h2>Tambah Peserta</h2>
                            <p style={{ fontWeight: 'normal', fontSize: '15px', color: '#FFFFFF' }}>Silahkan isi data peserta berikut</p>
                        </div>
                    </Modal.Title>
                </Modal.Header >
                <Modal.Body style={{ backgroundColor: '#FFFFFF' }}>
                    <EditParticipantComp
                        participant={participant}
                        close={() => handleAfterSubmitParticipant()}
                    />
                </Modal.Body>
            </Modal>

            <Modal
                show={showParticipantBp}
                size='lg'
                onHide={() => setShowParticipantBp(false)}
                centered
            >
                <Modal.Header
                    closeButton
                    style={{ backgroundColor: '#0C86D9', color: '#FFFFFF' }}
                >
                    <Modal.Title>
                        <div>
                            <h2 className='mt-3'>Tambah Peserta</h2>
                            <p className='mb-3' style={{ fontWeight: 'normal', fontSize: '15px', color: '#FFFFFF' }}>Silahkan isi data peserta berikut</p>
                        </div>
                    </Modal.Title>
                </Modal.Header >
                <Modal.Body style={{ backgroundColor: '#FFFFFF' }}>
                    <AddParticipantBpComp
                        bpId={bpId}
                        close={() => handleAfterSubmitParticipant()}
                    />
                </Modal.Body>
            </Modal>

            <Modal
                show={showEditParticipantBp}
                size='lg'
                onHide={() => setShowEditParticipantBp(false)}
                centered
            >
                <Modal.Header
                    closeButton
                    style={{ backgroundColor: '#0C86D9', color: '#FFFFFF' }}
                >
                    <Modal.Title>
                        <div className='mt-3 mb-3'>
                            <h2>Ubah Peserta</h2>
                            <p style={{ fontWeight: 'normal', fontSize: '15px', color: '#FFFFFF' }}>Silahkan isi data yang diubah</p>
                        </div>
                    </Modal.Title>
                </Modal.Header >
                <Modal.Body style={{ backgroundColor: '#FFFFFF' }}>
                    <EditParticipantBpComp
                        participant={participantBp}
                        close={() => handleAfterSubmitParticipant()}
                    />
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default FormKatalogParticipant
